<template lang="pug">
  pagina
    breadcrumb(slot="breadcrumb", :itens="this.breadcrumb")
    template(slot="principal"): google-search
    sidebar(slot="lateral")
</template>

<script>
  import Breadcrumb from 'MODULES/Breadcrumb'
  import Pagina from 'MODULES/Pagina'
  import Sidebar from 'MODULES/Sidebar'
  import GoogleSearch from 'MODULES/GoogleSearch'

  import * as config from '../../js/config'

  export default {
    components: {
      Breadcrumb,
      Pagina,
      Sidebar,
      GoogleSearch
    },
    data () {
      return {
        breadcrumb: [
          { nome: 'Busca' }
        ]
      }
    },
    head: {
      title: function () {
        return {
          inner: config.SITE_TITLE + ' - Busca'
        }
      },
      meta: [
        {
          name: 'description', content: config.SITE_DESC + ' - área de busca do site', id: 'description'
        }
      ]
    },
    methods: {
      busca () {
        let cx = '003075121585300769612:-ab5r55n5je'
        let gcse = document.createElement('script')
        gcse.type = 'text/javascript'
        gcse.async = true
        gcse.src = 'https://cse.google.com/cse.js?cx=' + cx
        let s = document.getElementsByTagName('script')[0]
        s.parentNode.insertBefore(gcse, s)
      }
    },
    mounted: function () {
      this.busca()
    }
  }
</script>



// WEBPACK FOOTER //
// Busca.vue?2b439bba